import { Outlet } from "react-router-dom";
import Lottie from "lottie-react";
import blobAnimation1 from "../assets/lottie/blob.json";
import blobAnimation2 from "../assets/lottie/blob.json";
import lineAnimation1 from "../assets/lottie/line.json";
import lineAnimation2 from "../assets/lottie/line.json";
import { useEffect, useState } from "react";
import "./Layout.css";

const Layout = () => {
  const [floatingElements, setFloatingElements] = useState([]);

  // Floating ilaç elementleri oluştur
  useEffect(() => {
    const elements = [];
    for (let i = 0; i < 8; i++) {
      elements.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 20 + 10,
        delay: Math.random() * 5,
        duration: Math.random() * 10 + 10,
        type: ["pill", "capsule", "syringe", "heart"][
          Math.floor(Math.random() * 4)
        ],
      });
    }
    setFloatingElements(elements);
  }, []);

  return (
    <main className="App layout-main">
      {/* Ana Blob Animasyonları */}
      <div className="blob-animation blob-1">
        <Lottie
          animationData={blobAnimation1}
          loop={true}
          className="lottie-full"
        />
      </div>

      <div className="blob-animation blob-2">
        <Lottie
          animationData={blobAnimation2}
          loop={true}
          className="lottie-full"
        />
      </div>

      {/* Line Animasyonları */}
      <div className="line-animation line-1">
        <Lottie
          animationData={lineAnimation1}
          loop={true}
          className="lottie-full"
        />
      </div>

      <div className="line-animation line-2">
        <Lottie
          animationData={lineAnimation2}
          loop={true}
          className="lottie-full"
        />
      </div>

      {/* Floating İlaç Elementleri */}
      {floatingElements.map((element) => (
        <div
          key={element.id}
          className="floating-element"
          style={{
            left: `${element.x}%`,
            top: `${element.y}%`,
            width: `${element.size}px`,
            height: `${element.size}px`,
            animation: `float${element.id} ${element.duration}s ease-in-out infinite`,
            animationDelay: `${element.delay}s`,
          }}
        >
          {element.type === "pill" && <div className="pill" />}
          {element.type === "capsule" && <div className="capsule" />}
          {element.type === "syringe" && <div className="syringe" />}
          {element.type === "heart" && <div className="heart" />}
        </div>
      ))}

      {/* Gradient Overlay */}
      <div className="gradient-overlay" />

      {/* Pulse Effect */}
      <div className="pulse-effect" />

      <Outlet />
    </main>
  );
};

export default Layout;
